export const SCROLLABLE_PANEL_PROPERTIES = {
  hasPresetSelectHeader: false,
};
